import api from './api';

/**
 * The environment's sign-in policy, as the server describes it.
 *
 * Read once at startup so the login page offers only the methods the server
 * will accept, asks Microsoft for the right directory, and the sign-up page
 * knows which email domains may register. The server enforces the same
 * policy on every authenticated request; this only shapes what is shown.
 *
 * It also carries the support address, because this is the one read the
 * client makes before anyone has signed in and the pages that need an
 * address most are the ones a refusal lands on.
 */
export const DEFAULT_AUTH_CONFIG = {
    methods: ['password', 'microsoft'],
    password: { allowedDomains: [] },
    microsoft: { tenant: process.env.REACT_APP_MICROSOFT_TENANT || 'common' },
    // The one field with no client-side default worth having. The server owns
    // the address, and an address guessed here would be printed as a mailto
    // and read as a promise; empty means "not known yet", and every surface
    // that shows it falls back to saying nothing rather than to a dead link.
    supportEmail: '',
};

export const authConfigService = {
    async getAuthConfig() {
        const response = await api.get('/auth/config');
        return response.data;
    },
};

export default authConfigService;
